import { render, staticRenderFns } from "./UirSetting.vue?vue&type=template&id=341d045c&scoped=true"
import script from "./UirSetting.vue?vue&type=script&lang=js"
export * from "./UirSetting.vue?vue&type=script&lang=js"
import style0 from "./UirSetting.vue?vue&type=style&index=0&id=341d045c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341d045c",
  null
  
)

export default component.exports